import { SessionStatus } from './session';

export type DatePreset = 'today' | 'last7' | 'last30' | 'all';

export interface SessionFilters {
  datePreset: DatePreset;
  dateFrom: string | null; // yyyy-MM-dd format, null when using preset
  dateTo: string | null; // yyyy-MM-dd format, null when using preset
  ward: string; // empty string = all wards
  status: SessionStatus | 'all';
}

export const DEFAULT_FILTERS: SessionFilters = {
  datePreset: 'all',
  dateFrom: null,
  dateTo: null,
  ward: '',
  status: 'all',
};
